export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-2-96f940bf045085870910ea36af0ca317.jpg";